module.exports = __webpack_public_path__ + "img/20200702_172310.83d7fde4.jpg";